import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import editapi from '../api/transcriptapi';
import sadminapi from '../api/sadminapi';
import loginapi from '../api/login';
import { AiOutlineDownload } from "react-icons/ai";
import { APISERVERURL } from '../APIServerURL';
const gradeOptions = ["","O", "A+", "A", "B+", "B", "C+", "C", "P", "F", "W", "AB","ABS"];

const CourseGradeTable = ({ courseMap, onSave ,user,onDelete}) => {
  const [courses, setCourses] = useState(courseMap);

  const handleGradeChange = (index, newGrade) => {
    const updated = [...courses];
    updated[index].grade = newGrade;
    setCourses(updated);
  };
  
const handleCheckboxChange = (index) => {
    const updated = [...courses];
    updated[index].markDelete = !updated[index].markDelete;
    setCourses(updated);
  };

  const handleSave = () => {
    // You can add validation or filter out unchanged data here
    onSave(courses);
  };
const handleDelete = () => {
    const marked = courses.filter((c) => c.markDelete);
    onDelete(marked); // You might want to send only the marked ones
  };


  return (
    <div className="overflow-x-auto">

       {user !== 'coe' &&(<table className="min-w-full border border-gray-300 rounded-lg mt-4 text-sm">
        <thead className="bg-gray-100">
          <tr>            
        
             <th className="px-4 py-2 border">Session</th>
            <th className="px-4 py-2 border">Semester</th>
            <th className="px-4 py-2 border">Course Code</th>
             <th className="px-4 py-2 border">Credit</th>
            <th className="px-4 py-2 border">Type</th>
            <th className="px-4 py-2 border">Grade</th>
          </tr>
        </thead>
        <tbody>
          {courses.map((course, index) => (
           <tr
                key={course.course_code + index}
                className={`${
                  course.markDelete ? 'bg-red-200' : index % 2 === 0 ? 'bg-white' : 'bg-blue-100'
                }`}
              >
             
                <td className="px-4 py-2 border text-center">{course.session}</td>
              <td className="px-4 py-2 border text-center">{course.semester}</td>
             <td className="px-4 py-2 border">{course.course_code}</td>
             <td className="px-4 py-2 border">{course.credit}</td>
              <td className="px-4 py-2 border">{course.course_type}</td>
              
              <td className="px-4 py-2 border">{course.grade}</td>
            </tr>
          ))}
        </tbody>
      </table>)}

      {user === 'coe' &&(<table className="min-w-full border border-gray-300 rounded-lg mt-4 text-sm">
        <thead className="bg-gray-100">
          <tr>            
           <th className="px-4 py-2 border">Mark Delete</th>
             <th className="px-4 py-2 border">Session</th>
            <th className="px-4 py-2 border">Semester</th>
            <th className="px-4 py-2 border">Course Code</th>
             <th className="px-4 py-2 border">Credit</th>
            <th className="px-4 py-2 border">Type</th>
            <th className="px-4 py-2 border">Grade</th>
            <th className="px-4 py-2 border">Grade</th>
          </tr>
        </thead>
        <tbody>
          {courses.map((course, index) => (
           <tr
                key={course.course_code + index}
                className={`${
                  course.markDelete ? 'bg-red-200' : index % 2 === 0 ? 'bg-white' : 'bg-blue-100'
                }`}
              >
             <td className="px-4 py-2 border text-center">
                <input
                    type="checkbox"
                    checked={!!course.markDelete}
                    onChange={() => handleCheckboxChange(index)}
                    className="w-5 h-5"
                  />
              </td>
                <td className="px-4 py-2 border text-center">{course.session}</td>
              <td className="px-4 py-2 border text-center">{course.semester}</td>
             <td className="px-4 py-2 border">{course.course_code}</td>
             <td className="px-4 py-2 border">{course.credit}</td>
              <td className="px-4 py-2 border">{course.course_type}</td>
              <td className="px-4 py-2 border">
                <select
                  value={course.grade}
                  onChange={(e) => handleGradeChange(index, e.target.value)}
                  className="border rounded px-2 py-1 w-full"
                >
                  {gradeOptions.map((grade) => (
                    <option key={grade} value={grade}>
                      {grade}
                    </option>
                  ))}
                </select>
              </td>
              <td className="px-4 py-2 border">{course.grade}</td>
            </tr>
          ))}
        </tbody>
      </table>)}

     
  {courses.some((c) => c.markDelete) && ( <div className="mt-4 bg-red-100 p-4 rounded">
    <p className="text-red-800 font-medium">
      ⚠️ {courses.filter((c) => c.markDelete).length} course(s) will be deleted:{" "}
      {courses
        .filter((c) => c.markDelete)
        .map((c) => c.course_code)
        .join(", ")}
    </p></div>
  )}


      <div className="mt-4">
        {user === 'coe' && ( <div className="flex justify-between">
  <button
    onClick={handleSave}
    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
  >
    Save Grades
  </button>
 <button
  onClick={handleDelete}
  disabled={!courses.some((c) => c.markDelete)}
  className={`px-4 py-2 rounded text-white
    ${courses.some((c) => c.markDelete)
      ? 'bg-red-600 hover:bg-red-700'
      : 'bg-gray-400 cursor-not-allowed'}
  `}
>
  DELETE MARKED
</button>

  
</div>)}
      </div>
    </div>
  );
};

function RunningTranscript({accessToken,setAccessToken,setRefreshFailed,sessions  }) {
  const navigate = useNavigate();
  const [rollno,setRollno]=useState('');  
  const [session,setSession]=useState('');  
  const [error,setError]=useState('');
  const [result,setResult]=useState(null);
  const [user,setUser]=useState('');
    const [isDownloading,setIsDownloading]=useState(false);
        const [isDownloadingTx,setIsDownloadingTx]=useState(false);
           const [isDownloadingTxLegal,setIsDownloadingTxLegal]=useState(false);
  const handleGoBack = () => {
    navigate(`/`); 
  };

const sessionChanged = async (e) => {
    const session = e.target.value;
    setSession(session);

  };

const handleRollnoChange = (e) => {
    setRollno(e.target.value);
  
    setError('');
   
  };


    
    async function handleSearch()
        {
           setResult(null);
          try{
            const response= await editapi.post('/getRunningTranscript',{ rollno},{headers:{'Authorization':`Bearer ${accessToken}`}});    
              setResult(response.data.result);
              setUser(response.data.userName);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editapi.post('/getRunningTranscript',{ rollno},{headers:{'Authorization':`Bearer ${nat}`}});    
                       setResult(response.data.result);   
                        setUser(response.data.userName); 
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
        }
  
           
    async function handleSave(courses)
        {
          try{
            const response= await sadminapi.post('/updateCourseMapOfStudent',{ rollno,courses,session},{headers:{'Authorization':`Bearer ${accessToken}`}});    
              await handleSearch();
              
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await sadminapi.post('/updateCourseMapOfStudent',{ rollno,courses,session},{headers:{'Authorization':`Bearer ${nat}`}});    
                       //setResult(response.data.result);   alert("OK"); 
                       await handleSearch();
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
        }

           
    async function handleDelete(courses)
        {
          try{
            const response= await sadminapi.post('/deleteCourses',{ rollno,courses,session},{headers:{'Authorization':`Bearer ${accessToken}`}});    
              await handleSearch();
              
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await sadminapi.post('/deleteCourses',{ rollno,courses,session},{headers:{'Authorization':`Bearer ${nat}`}});    
                       //setResult(response.data.result);   alert("OK"); 
                       await handleSearch();
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
        }

        function downloadFile(fname)
            {
              fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
                response.blob().then((blob) => {
                 
                    // Creating new object of PDF file
                    const fileURL =
                        window.URL.createObjectURL(blob);
                         
                    // Setting various property values
                    let alink = document.createElement("a");
                    alink.href = fileURL;
                    alink.download = fname;
                    alink.click();
                    //setIsloading(false);
                });
              });
            }
          async function handleDownloadGradeCards(e,bg)
            {
              e.preventDefault();
              setIsDownloading(true);
              try{
                //session, batch, semester,bg
                const response= await editapi.post('/getAllGradeCardOfAStudent',{rollno,bg:'YES'},{headers:{'Authorization':`Bearer ${accessToken}`}});    
                alert(response.data);
                downloadFile(response.data);
              }
              catch(err)
              {
                try{
                  const config = { withCredentials: true };
                  const x=await loginapi.get('/getAccessToken',config);
                  
                  const nat=x['data']['accessToken'];
                  setAccessToken(nat);
                  try{       
                    const response= await editapi.post('/getAllGradeCardOfAStudent',{rollno,bg:'YES'},{headers:{'Authorization':`Bearer ${nat}`}});    
                    downloadFile(response.data);
                   }
                   catch(err)
                   {
                    alert('unusual error newposts.js');
                   }
                }
                catch(err)
                {
                  alert('failed');
                }
        
              }
              finally
              {
                setIsDownloading(false);
              }
            }

async function handleDownloadTranscript(e,bg="yes",type="A4")
            {
              e.preventDefault();
              if(type==="A4")
              {
                setIsDownloadingTx(true);
              }
              else{
                setIsDownloadingTxLegal(true);
              }
              
              try{
                //session, batch, semester,bg
                const response= await editapi.post('/printTranscriptOfAStudent',{rollno,bg:'YES',type:type},{headers:{'Authorization':`Bearer ${accessToken}`}});    
                alert(response.data);
                downloadFile(response.data);
              }
              catch(err)
              {
                try{
                  const config = { withCredentials: true };
                  const x=await loginapi.get('/getAccessToken',config);
                  
                  const nat=x['data']['accessToken'];
                  setAccessToken(nat);
                  try{       
                    const response= await editapi.post('/printTranscriptOfAStudent',{rollno,bg:'YES',type:type},{headers:{'Authorization':`Bearer ${nat}`}});    
                    downloadFile(response.data);
                   }
                   catch(err)
                   {
                    alert('unusual error newposts.js');
                   }
                }
                catch(err)
                {
                  alert('failed');
                }
        
              }
              finally
              {
                if(type==="A4")
              {
                setIsDownloadingTx(false);
              }
              else{
                setIsDownloadingTxLegal(false);
              }
              }
            }

            
  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> TRANSCRIPT DETAILS</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

    

      <div className="flex flex-col justify-center gap-4 mt-4">
       
        
        

        <div className="w-full flex flex-col items-center justify-center mt-4 ">
                <div
                  className="flex flex-col items-center justify-center  w-full max-w-[600px]  p-1 text-sm mb-2 "
                >
                 <p className="text-center">Rollno</p>

                <input
                                type="text" 
                                name="txtRollno"
                                value={rollno}
                                onChange={handleRollnoChange}
                              className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
                              />
               </div>

               {false && (<div
                  className="flex flex-col items-center justify-center  w-full max-w-[600px] p-1 text-sm mb-2 "
                >
                <p className="text-center">Select Exam session</p>
            <select
        value={session}
        onChange={(e) => sessionChanged(e)}
        className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
      >
        <option value="">-- Choose a session --</option>
        {sessions.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>
               </div>)}


              <button className="bg-green-500 text-white font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300 hover:bg-green-600 hover:scale-105 active:scale-95"
              onClick={handleSearch}>
                SEARCH
              </button>

{result?.result&&(
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-6">
    <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Name</span>
    <p className="text-base font-medium text-gray-800">{result.result.studentDetails.name}</p>
  </div>


  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Total All Credit</span>
    <p className="text-base font-medium text-gray-800">{result.result.totalAllCredit}</p>
  </div>

  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Total Major Credit</span>
    <p className="text-base font-medium text-gray-800">{result.result.totalMajorCredit}</p>
  </div>

<div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Total Major Point</span>
    <p className="text-base font-medium text-gray-800">{result.result.totalMajorGp}</p>
  </div>
  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Total All Point</span>
    <p className="text-base font-medium text-gray-800">{result.result.totalAllGp}</p>
  </div>

  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Major CGPA</span>
    <p className="text-base font-medium text-gray-800">{result.result.majorCgpa}</p>
  </div>

  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">All CGPA</span>
    <p className="text-base font-medium text-gray-800">{result.result.allCgpa}</p>
  </div>  

  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Total Credit Earned</span>
    <p className="text-base font-medium text-gray-800">{result.result.totalCreditEarned}</p>
  </div>
</div>
)}


               {result?.result?.courseMap && (
  <div className="p-4">
      <h2 className="text-lg font-bold mb-2 text-center">Course Grade Table</h2>
      <CourseGradeTable courseMap={result?.result?.courseMap} onSave={handleSave} user={user} onDelete={handleDelete}/>
      
      <div className="flex flex-wrap justify-center gap-2 m-3">
              { true && <button 
        onClick={(e) => handleDownloadGradeCards(e, 'yes')} 
        disabled={isDownloading}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg transition duration-200 text-xs 
                    ${isDownloading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-800 text-white'}`}
      >
        {isDownloading ? (
          <span>Please Wait...</span>
        ) : (
          <>
            <AiOutlineDownload size={20} />
            GradeCards
          </>
        )}
      </button>}

<button 
        onClick={(e) => handleDownloadTranscript(e, 'yes',"A4")} 
        disabled={isDownloadingTx}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg transition duration-200 text-xs 
                    ${isDownloadingTx ? 'bg-gray-400 cursor-not-allowed' : 'bg-pink-500 hover:bg-pink-800 text-white'}`}
      >
        {isDownloadingTx ? (
          <span>Please Wait...</span>
        ) : (
          <>
            <AiOutlineDownload size={20} />
            TRANSCRIPT A4
          </>
        )}
      </button>

<button 
        onClick={(e) => handleDownloadTranscript(e, 'yes',"Legal")} 
        disabled={isDownloadingTxLegal}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg transition duration-200 text-xs 
                    ${isDownloadingTxLegal ? 'bg-gray-400 cursor-not-allowed' : 'bg-yellow-500 hover:bg-yellow-800 text-white'}`}
      >
        {isDownloadingTxLegal ? (
          <span>Please Wait...</span>
        ) : (
          <>
            <AiOutlineDownload size={20} />
            TRANSCRIPT LEGAL
          </>
        )}
      </button>
            </div>
    </div>
)}


        </div>

       


      </div>
      </div>
    </main>
  );
}

export default RunningTranscript;
